import { useTranslation } from 'react-i18next';
import { HomeCardsPage } from '../components/home-cards.tsx';
import { PageHeader, Panel } from '../components/ui.tsx';
import { FINANCE_CARDS } from './finance/home-cards.ts';

/** Lugar reservado no menu; o conteúdo chega com o módulo financeiro. */
function ComingSoon({ screen }: { screen: string }) {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t(`nav.${screen}`)} description={t(`finance.${screen}`)} />
      <Panel title={t('finance.soonTitle')}>
        <p className="text-sm text-muted">{t('finance.soon')}</p>
      </Panel>
    </>
  );
}

/** Consultar pendências: todos os cartões do Financeiro, mesmo os zerados (ADR 0097). */
export function FinancePendingPage() {
  const { t } = useTranslation();
  return (
    <HomeCardsPage
      config={FINANCE_CARDS}
      title={t('nav.financePending')}
      description={t('finance.homeCards.pendingAbout')}
    />
  );
}

export function ReceivablesPage() {
  return <ComingSoon screen="receivables" />;
}

export function ExpenseReimbursementsPage() {
  return <ComingSoon screen="expenseReimbursements" />;
}
